module.exports = __webpack_public_path__ + "img/index_grey.dc338848.svg";